import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

export function useIsMobile() {
  const breakpoints = useBreakpoints(breakpointsTailwind, { ssrWidth: breakpointsTailwind.lg })
  return breakpoints.smaller('md')
}
